/**
 * Server-meter opt-in for the browser-facing LLM proxies (security
 * remediation slice 2, 2026-09-15 —
 * docs/PLAN-security-remediation-20260915.md §2.1).
 *
 * Until this slice the browser debited its own wallet after every proxied
 * model call (walletRepository.createExpenseWithBalanceUpdate) — the same
 * write access that let a signed-in user set any balance and cash it out.
 * users/{uid}/wallet is server-write-only now, so a request whose usage is
 * billed carries this header and the proxy (anthropicProxy, openRouterProxy,
 * perplexityProxy) records the expense through recordAccountExpense against
 * the workspace named by X-Account-Id (src/services/accountHint.ts).
 *
 * Send it from exactly the calls the browser used to bill — the same set of
 * requests, just debited on the other side of the wire. Calls that were
 * never billed (thread labels, orchestrator decisions, structured-event
 * rendering) do not send it; src/services/__tests__/serverMeterOptIn.test.ts
 * pins both lists.
 */
export const SERVER_METER_HEADER_NAME = 'X-Prest0n-Meter';

export const SERVER_METER_HEADERS: Readonly<Record<string, string>> = Object.freeze({
  [SERVER_METER_HEADER_NAME]: 'server',
});
